<template>
  <div class="view-admin">
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.view-admin {
  overflow: auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  justify-items: center;
}
</style>
